// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsSidebar-cls1___22559a1667bd45f24b4","cls2":"ToolsSidebar-cls2__e354eda0666f358517fa ToolsSidebar-cls1___22559a1667bd45f24b4"};